import { Assignment } from './types';
import { parsePlainDateString } from '@/utils/dateTransforms';

export type RawAssignmentData = {
  id: number;
  start_date: string;
  end_date: string;
  employee_id: number;
  hourly_rate: number;
  daily_hours: number;
  isBillable: boolean;
  hour_overrides: {
    id: number;
    start_date: string; // This is the string format from DB 'YYYY-MM-DD'
    end_date: string;   // This is the string format from DB 'YYYY-MM-DD'
    daily_hours: number;
    description: string; // New mandatory field
    isBillable: boolean; // New field for billable status
  }[];
};

/**
 * Transforms raw assignment data from the database into typed Assignment objects
 * with proper date handling and defaults for optional fields
 * 
 * @param data Raw assignment data from Supabase query
 * @returns Processed Assignment array with parsed dates and normalized fields
 */
export function parseAssignmentData<T extends RawAssignmentData>(data: T[]): any[] {
  return (data).map(assignment => {
    // Process hour overrides
    const parsedOverrides = assignment.hour_overrides ? 
      assignment.hour_overrides.map(override => ({
        ...override,
        // Convert string dates to Date objects
        start_date: parsePlainDateString(override.start_date),
        end_date: parsePlainDateString(override.end_date),
        description: override.description, // Include description
        isBillable: override.isBillable !== false // Default to true if not explicitly false
      })) : [];

    return {
      ...assignment,
      // Convert string dates to Date objects
      start_date: parsePlainDateString(assignment.start_date),
      end_date: parsePlainDateString(assignment.end_date),
      hour_overrides: parsedOverrides
    };
  });
}